import { StyleSheet } from 'react-native'
import { ThemedValues, ThemedShared } from 'styles/themed'
import { colorList } from 'utils/colors'

export const LoadingStyles = StyleSheet.create( {
	fullscreen: {
		flex: 1,
		width: '100%',
		borderRadius: 0,
	},
	container: {
		flex: 1,
		justifyContent: "center",
		alignItems: 'center',
		flexDirection: "column",
		padding: ThemedShared.paddingSmall.padding
	},
	
	textStyle: {
		marginTop: 8,
		width: '100%',
		textAlign: 'center'
	},
	
	title: {
		marginTop: 8,
		width: '100%',
		textAlign: 'center',
		fontSize: 20,
		color: colorList.WHITE.primary,
		fontWeight: '700'
	},
	spinnerContainer: {
		justifyContent: "center",
		alignItems: 'center',
		width: 60,
		height: 60,
		borderRadius: 30,
		overflow: 'hidden'
	},
	spinnerBackground: {
		width: '100%',
		height: '100%'
	},
	spinner: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		top: 0,
		
		justifyContent: "center",
		alignItems: 'center',
	},
	spinnerOpacity: {
		opacity: 0.6
	},
	spinnerOuter: {
		width: 60,
		borderWidth: 2
	},
	spinnerInner: {
		width: 54,
		borderWidth: 2
	}
});

export const LoadingStylesSizeXS = StyleSheet.create( {
	spinnerContainer: {
		width: 20,
		height: 20,
		borderRadius: ThemedValues.borderRadius,
	},
	spinnerOuter: {
		width: 20,
		borderWidth: 1
	},
	spinnerInner: {
		width: 16,
		borderWidth: 1
	}
});

export const LoadingStylesSizeS = StyleSheet.create( {
	spinnerContainer: {
		width: 30,
		height: 30,
		borderRadius: ThemedValues.borderRadius,
	},
	spinnerOuter: {
		width: 30,
		borderWidth: 1
	},
	spinnerInner: {
		width: 26,
		borderWidth: 1
	}
});

export const LoadingStylesSizeL = StyleSheet.create( {
	spinnerContainer: {
		width: 90,
		height: 90,
		borderRadius: 45,
	},
	spinnerOuter: {
		width: 92,
		borderWidth: 2.5
	},
	spinnerInner: {
		width: 84,
		borderWidth: 2.5
	}
})
